import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=0f05f9b4&scoped=true"
import script from "./Pagination.js?vue&type=script&lang=js&external"
export * from "./Pagination.js?vue&type=script&lang=js&external"
import style0 from "./Pagination.scss?vue&type=style&index=0&id=0f05f9b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05f9b4",
  null
  
)

export default component.exports